<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27 3H11a2 2 0 00-2 2v11H5a2 2 0 00-2 2v7a4 4 0 004 4h20a2 2 0 002-2V5a2 2 0 00-2-2zM9 25a2 2 0 01-4 0v-7h4zm18 2H10.44a3.91 3.91 0 00.56-2V5h16z"/><path d="M14 13h10a1 1 0 001-1V8a1 1 0 00-1-1H14a1 1 0 00-1 1v4a1 1 0 001 1zm0-5h10v4H14zM13.5 17H24a.5.5 0 000-1H13.5a.5.5 0 000 1zM13.5 20.5H24a.5.5 0 000-1H13.5a.5.5 0 000 1zM13.5 24H19a.5.5 0 000-1h-5.5a.5.5 0 000 1z"/></svg>